/**
 * @description 포인트 지급/회수 형태 키워드
 */
export enum ServiceTypeE {
    /** 즉시지급 */
    'IMMEDIATELY' = 'IMMEDIATELY',
    /** 예약지급 */
    'RESERVE' = 'RESERVE',
    /** 회수 */
    'RETRIEVE' = 'RETRIEVE',
}

export enum ServiceTypeKorE {
    /** IMMEDIATELY */
    '즉시지급' = '즉시지급',
    /** RESERVE */
    '예약지급' = '예약지급',
    /** RETRIEVE */
    '회수' = '회수',
}

/**
 * @description 포인트 지급/회수 형태 타입
 */
export type ServiceTypeT = keyof typeof ServiceTypeE;
export type ServiceTypeKorT = keyof typeof ServiceTypeKorE;

/**
 * @description 포인트 지급/회수 대상 형태 키워드
 */
export enum TargetServiceTypeE {
    /** 지급 */
    'PROVIDE' = 'PROVIDE',
    /** 회수 */
    'RETRIEVE' = 'RETRIEVE',
}
export enum TargetServiceTypeKorE {
    /** PROVIDE */
    '지급' = '지급',
    /** RETRIEVE */
    '회수' = '회수',
}

/**
 * @description 포인트 지급/회수 대상 형태 타입
 */
export type TargetServiceTypeT = keyof typeof TargetServiceTypeE;
export type TargetServiceTypeKorT = keyof typeof TargetServiceTypeKorE;

/**
 * @description 포인트 지급/회수 요청 상태 키워드
 */
export enum RequestStatusE {
    /** 요청대기 */
    'REQUEST_READY' = 'REQUEST_READY',
    /** 반려 */
    'REJECT' = 'REJECT',
    /** 승인 */
    'CONFIRM' = 'CONFIRM',
    /** 요청취소 */
    'REQUEST_CANCEL' = 'REQUEST_CANCEL',
    /** 처리중 */
    'PROCESSING' = 'PROCESSING',
    /** 처리완료 */
    'FINISHED' = 'FINISHED',
}
export enum RequestStatusKorE {
    /** REQUEST_READY */
    '요청대기' = '요청대기',
    /** REJECT */
    '반려' = '반려',
    /** CONFIRM */
    '승인' = '승인',
    /** REQUEST_CANCEL */
    '요청취소' = '요청취소',
    /** PROCESSING */
    '처리중' = '처리중',
    /** FINISHED */
    '처리완료' = '처리완료',
}

/**
 * @description 포인트 지급/회수 요청 상태 타입
 */
export type RequestStatusT = keyof typeof RequestStatusE;
export type RequestStatusKorT = keyof typeof RequestStatusKorE;

/**
 * @description 포인트 지급/회수 요청내역 날짜/기간 검색 키워드
 */
export enum PeriodTypeE {
    /** 등록일 */
    'REGISTER_DATE' = 'REGISTER_DATE',
    /** 지급예정일 */
    'RESERVE_DATE' = 'RESERVE_DATE',
}

/**
 * @description 포인트 지급/회수 요청내역 날짜/기간 검색 타입
 */
export type PeriodTypeT = keyof typeof PeriodTypeE;

/**
 * @description 포인트 지급/회수 대상 처리상태 키워드
 */
export enum TargetStatusE {
    /** 처리대기 */
    'REQUEST_READY' = 'REQUEST_READY',
    /** 반려 */
    'REJECT' = 'REJECT',
    /** 요청취소 */
    'REQUEST_CANCEL' = 'REQUEST_CANCEL',
    /** 가입대기 */
    'UNSIGNED' = 'UNSIGNED',
    /** 승인 */
    'CONFIRM' = 'CONFIRM',
    /** 처리완료 */
    'FINISHED' = 'FINISHED',
    /** 처리실패 */
    'FAIL' = 'FAIL',
}
export enum TargetStatusKorE {
    /** REQUEST_READY */
    '처리대기' = '처리대기',
    /** REQUEST_CANCEL */
    '요청취소' = '요청취소',
    /** REJECT */
    '반려' = '반려',
    /** UNSIGNED */
    '가입대기' = '가입대기',
    /** CONFIRM */
    '승인' = '승인',
    /** FINISHED */
    '처리완료' = '처리완료',
    /** FAIL */
    '처리실패' = '처리실패',
}

/**
 * @description 포인트 지급/회수 대상 처리상태 타입
 */
export type TargetStatusT = keyof typeof TargetStatusE;
export type TargetStatusKorT = keyof typeof TargetStatusKorE;
